export const eventSettings_functions = (hceSettings) => {
  return {
    getHomeGlobalSetting: (key, subKey) => {
      const { global } = hceSettings.home ?? {}
      const globalItem = global ? global[key] : {}
      if (globalItem) {
        if (subKey) {
          return globalItem ? globalItem[subKey] : null
        } else {
          return globalItem
        }
      } else {
        return null
      }
    },
    getGlobalSetting: (key, subKey) => {
      const { global } = hceSettings.events ?? {}
      const globalItem = global ? global[key] : {}
      if (globalItem) {
        if (subKey) {
          return globalItem ? globalItem[subKey] : null
        } else {
          return globalItem
        }
      } else {
        return null
      }
    },
    getGlobalViewItem: (key) => {
      const { viewItems } = hceSettings.events ?? {}
      const viewItem = viewItems ? viewItems[key] : {}
      return viewItem
    },
    getGlobalViewItemProps: (key) => {
      const { viewItems } = hceSettings.events ?? {}
      const viewItem = viewItems ? viewItems[key] : {}
      const { props } = viewItem ?? {}
      return props
    },
    mergeViewItemProps: (viewItem) => {
      const { props, key } = viewItem ?? {}
      const { viewItems } = hceSettings.events ?? {}
      const viewItem_g = viewItems ? viewItems[key] : {}
      const { props: props_g } = viewItem_g ?? {}
      const np = {}
      if (props_g) {
        Object.keys(props_g).forEach(pKey => {
          if (props[pKey]) {
            const prop_g = props_g[pKey]
            props[pKey] = _.merge(prop_g, props[pKey])
          }
        })
      }
      return np
    }
  }
}

export const homeSettings_functions = (states_all) => {
  return {
    getSignInHelp: (helpType) => {
      const { homeSettings } = states_all.home ?? {}
      const { global } = homeSettings ?? {}
      const { signInHelp } = global ?? {}
      const help = signInHelp ? signInHelp[helpType] : null
      return help
    }
  }
}